import getRouterView from '@/router/helpers';

export default {
    path: '/adoptions',
    meta: {
        title: 'Search',
        documentTitle: 'Adoptions',
        requiresAuth: true,
    },
    component: getRouterView(), // create an anonymous component so we can have proper route nesting, like Butler Central
    children: [
        {
            path: '',
            name: 'AdoptionSearch',
            meta: {
                documentTitle: 'Adoption Search',
            },
            component: () => import( /* webpackChunkName: "AdoptionSearch" */ '@/views/Adoptions/AdoptionSearch' ),
        },
        {
            path: 'id',
            component: getRouterView(),
            children: [
                {
                    path: '',
                    redirect: '/adoptions',
                },
                {
                    path: ':id',
                    name: 'AdoptionDetail',
                    meta: {
                        documentTitle: 'Adoption Detail',
                    },
                    component: () => import( /* webpackChunkName: "AdoptionDetail" */ '@/views/Adoptions/AdoptionDetail' ),
                },
            ],
        },
    ],
};
